import { Hammer } from "lucide-react";
import { Link } from "react-router-dom";

import { useI18n } from "@/i18n/useI18n";

/**
 * A placeholder that says what it is.
 *
 * The sidebar shows the whole validated information architecture from day one, so these
 * routes exist before their screens do. Saying plainly "not built yet" is better than a
 * blank page or a fake empty state — the shape of the product should be clickable, and
 * honest about how much of it is real.
 */
export function NotBuiltYet({ whatKey = "notBuilt.what.report" }: { whatKey?: string }) {
  const { t } = useI18n();

  return (
    <div className="px-4 py-16 lg:px-8">
      <div className="mx-auto max-w-md rounded-xl border border-dashed border-slate-300 bg-white px-6 py-12 text-center">
        <div className="mx-auto mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-slate-100 text-slate-400">
          <Hammer className="h-5 w-5" />
        </div>
        <h3 className="font-semibold text-slate-700">{t("notBuilt.title", { what: t(whatKey) })}</h3>
        <p className="mt-2 text-sm text-slate-500">{t("notBuilt.body")}</p>
        <Link to="/" className="mt-5 inline-block text-sm font-semibold text-brand-rose hover:underline">
          {t("notBuilt.back")}
        </Link>
      </div>
    </div>
  );
}
